import { render, staticRenderFns } from "./BinderPDFStampList.vue?vue&type=template&id=6d506f61&"
import script from "./BinderPDFStampList.vue?vue&type=script&lang=js&"
export * from "./BinderPDFStampList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports